import React from "react"

const DOTS = Array.from({ length: 8 })

const CircularProgress = ({ className = "", size = 40 }) => {
  const ringSize = size + 26

  return (
    <div
      className={className}
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        minHeight: "100px",
      }}
    >
      <div
        className="fromas-loader-wrapper"
        style={{
          width: ringSize,
          height: ringSize,
          marginLeft: -(ringSize / 2),
          marginTop: -(ringSize / 2),
        }}
      >
        <div className="fromas-loader-dots" aria-hidden>
          {DOTS.map((_, index) => (
            <span
              key={`fromas-dot-${index}`}
              className="fromas-loader-dot"
              style={{
                transform: `rotate(${index * 45}deg) translateY(-${ringSize / 2}px)`,
                animationDelay: `${index * 0.08}s`,
              }}
            />
          ))}
        </div>
        <img
          src={`${process.env.PUBLIC_URL || ""}/favicon.ico?v=5`}
          alt="Fromas Loader"
          className="fromas-loader fromas-loader-icon"
          style={{
            width: `${size}px`,
            height: `${size}px`,
          }}
          onError={(event) => {
            console.error("CircularProgress: Favicon not found", event)
            event.currentTarget.style.display = "none"
          }}
        />
      </div>
    </div>
  )
}

export default CircularProgress
